import React from "react";
import logoMark from "./logo-mark.png";

/**
 * CadLap brand logo mark.
 * The image is imported as a module so the bundler resolves and
 * fingerprints it — this guarantees it always loads regardless of
 * routing or PUBLIC_URL configuration, and busts the browser cache
 * automatically on each build.
 *
 * Props:
 *   size      — pixel size (width & height), default 36
 *   className — extra classes (e.g. "logo-spin")
 */
const Logo = ({ size = 36, className = "", alt = "CadLap logo" }) => (
  <img
    src={logoMark}
    width={size}
    height={size}
    alt={alt}
    className={`brand-logo ${className}`}
    draggable="false"
  />
);

export default Logo;
